import { state } from "@shared/template/StoreTemplates/FilterStoreTemplate"

export const initialState = () => ({
  uuid: null,
  isEditing: false,
  currentStep: 0,
  active: true,
  name: "",
  username: "",
  cpf: "",
  birthdate: "",
  email: "",
  phone:"",
  photo: "",
  gender: "",
  role: "",
  roleCategory: "",
  all_chains: false,
  pos: [],
  chains: [],
  states: [],
  providers: [],
  leaders: [],
  led: [],
  superior: null,
  hasHierarchy: false,
  superiorChain: [],
  favoritePos: "",
  isAdmin: false,

  address: {
    address: "",
    postcode: "",
    number: "",
    city: "",
    state: "",
    neighborhood: "",
    complement: ""
  },

  notificationsList: {
    unread: { number: 0 }
  },
  notification: {
    actionId: "",
    pathName: ""
  },
  loading: {
    show: false,
    message: ""
  },

  steps: ["Conta", "Acessos", "Hierarquia", "Liderança"],
  stepsNamesRoutes: ["", "user-account", "user-access", "user-hierarchy", "user-leadership"],
  chainsAccess: "allChains",
  selectedChains: [],
  selectedPos: [],

  rolesOptions: [],
  chainsOptions: [],
  posOptions: [],

  ...state
})
